export default {
  // Común
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    reset: 'Restablecer',
    export: 'Exportar',
    import: 'Importar',
    upload: 'Subir',
    download: 'Descargar',
    submit: 'Enviar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    refresh: 'Actualizar',
    loading: 'Cargando...',
    success: 'Operación exitosa',
    error: 'Operación fallida',
    warning: 'Advertencia',
    info: 'Información'
  },
  
  // Inicio de sesión
  login: {
    title: 'Inicio de Sesión',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Inicio de sesión fallido',
    notLoggedIn: 'No ha iniciado sesión...',
    systemTitle: 'Tecnología Ambiental Qinghe · Sistema de Gestión de Generadores de Hidrógeno',
    welcomeTitle: 'Bienvenido - Sistema de Gestión de Generadores de Hidrógeno',
    usernameMinLength: 'El nombre de usuario debe tener al menos 2 caracteres',
    passwordFormat: 'Formato de contraseña inválido',
    verificationCode: 'Error de código de verificación (distingue mayúsculas y minúsculas)'
  },
  
  // Página de administración
  admin: {
    title: 'Tecnología Ambiental Qinghe - Administración',
    dashboard: 'Panel de control',
    menu: 'Menú',
    logout: 'Cerrar sesión'
  },
  
  // Gestión de dispositivos
  device: {
    title: 'Gestión de Dispositivos',
    list: 'Lista de Dispositivos',
    add: 'Agregar Dispositivo',
    edit: 'Editar Dispositivo',
    delete: 'Eliminar Dispositivo',
    status: 'Estado del Dispositivo',
    type: 'Tipo de Dispositivo',
    online: 'En línea',
    offline: 'Desconectado',
    heartbeat: 'Datos de Latido',
    record: 'Registro de Operación',
    activate: 'Registro de Activación'
  },
  
  // Gestión de organizaciones
  org: {
    title: 'Gestión de Organizaciones',
    list: 'Lista de Organizaciones',
    add: 'Agregar Organización',
    edit: 'Editar Organización',
    delete: 'Eliminar Organización',
    name: 'Nombre de la Organización',
    code: 'Código de la Organización',
    type: 'Tipo de Organización'
  },
  
  // Gestión de tarjetas de agua
  card: {
    title: 'Gestión de Tarjetas de Agua',
    list: 'Lista de Tarjetas de Agua',
    add: 'Agregar Tarjeta de Agua',
    bind: 'Vincular Tarjeta de Agua',
    unbind: 'Desvincular Tarjeta de Agua',
    import: 'Importar Tarjeta de Agua',
    export: 'Exportar Tarjeta de Agua',
    serialNo: 'Número de Serie',
    cardNo: 'Número de Tarjeta',
    status: 'Estado'
  },
  
  // Configuración del sistema
  setting: {
    title: 'Configuración del Sistema',
    general: 'Configuración General',
    security: 'Configuración de Seguridad',
    notification: 'Configuración de Notificaciones'
  },
  
  // Estadísticas de datos
  stats: {
    title: 'Estadísticas de Datos',
    tds: 'Estadísticas TDS',
    volume: 'Estadísticas de Volumen',
    usage: 'Estadísticas de Uso'
  },
  
  // Pie de página
  footer: {
    copyright: '© 2023 - Tecnología Ambiental Qinghe Co., Ltd. Todos los derechos reservados',
    icp: 'Registro ICP: ',
    techSupport: '© Soporte Técnico: Guangzhou Guanjun Hydrogen Technology Co., Ltd.'
  },
  
  // Mensajes de error
  error: {
    network: 'Error de Red',
    server: 'Error del Servidor',
    permission: 'Permisos Insuficientes',
    param: 'Error de Parámetro',
    notFound: 'Datos No Encontrados',
    pageNotFound: 'Lo siento, la página que visitó no existe'
  },
  
  // Menú relacionado
  menu: {
    // Gestión de Dispositivos
    equipment: 'Biblioteca de Equipos y Filtros',
    filterRecord: 'Registro de Cambio de Filtros',
    version: 'Biblioteca de Versiones Domésticas',
    dataQuery: 'Consulta de Datos TCP',
    heartbeat: 'Datos de Latido',
    singleUse: 'Datos de Uso Único',
    bindStats: 'Estadísticas de Vinculación',
    
    // Gestión de Clientes
    customer: 'Gestión de Clientes',
    agentCheck: 'Revisión de Agentes',
    agentProfit: 'Gestión de Beneficios de Agentes',
    promotionRoute: 'Configuración de Ruta de Promoción',
    partyType: 'Gestión de Tipo de Partido',
    
    // Consulta de Datos MQTT
    mqttQuery: 'Consulta de Datos MQTT',
    statusQuery: 'Consulta de Estado',
    outputRecord: 'Consulta de Registro de Salida',
    debug: 'Página de Depuración de Dispositivos',
    waterTotal: 'Consulta de Total de Agua',
    
    // Gestión del Sistema
    adminAccount: 'Cuenta de Administrador',
    deviceType: 'Gestión de Tipo de Dispositivo',
    defaultSettings: 'Configuración Predeterminada del Sistema',
    flowConfig: 'Personalización de Flujo de Agua',
    waterConfig: 'Configuración de Temperatura y Agua',
    businessLog: 'Registro de Negocios',
    
    // Gestión de Pagos
    payment: 'Gestión de Pagos',
    order: 'Gestión de Pedidos',
    statistics: 'Estadísticas de Datos',
    waterPrice: 'Configuración de Precio del Agua',
    recharge: 'Recarga'
  }
}
